import { methods, ServiceMaker } from './index';

const { POST } = methods;

export const channelmapping = data => ServiceMaker(`v1/api/channel/mapping/`, POST, null, data);

export const reprocessPayment = data => ServiceMaker(`v1/api/payments/reprocess`, POST, null, data);